import React, {FC, Suspense, lazy, useMemo, useEffect} from 'react';
import {BrowserRouter as Router, Route, Switch, useLocation} from 'react-router-dom';
import {DFPSlotsProvider} from 'react-dfp';
import GA from 'react-ga';

import Loader from './components/Common/Loader';
import Menu from './components/Common/Menu';

import './assets/scss/fonts.scss';
import './assets/scss/globals.scss';

const MatchcenterPage = lazy(
  () => import(/* webpackChunkName: "matchcenter" */ './views/MatchcenterPage')
);
const MatchPage = lazy(() => import(/* webpackChunkName: "match" */ './views/MatchPage'));

// TODO: update match page path

const MatchcenterApp: FC = () => {
  const location = useLocation();

  useEffect(() => {
    GA.initialize('UA-482127-1');
    GA.ga('send', 'pageview', `${process.env.PUBLIC_URL}${location.pathname}`);
  }, [location]);

  const isApp = useMemo(() => {
    const query = new URLSearchParams(location.search);
    const appParam = query.get('sport24app');

    return appParam === 'true';
  }, [location]);
  return (
    <>
      {!isApp && <Menu />}
      <Suspense fallback={<Loader fullpage />}>
        <Switch>
          <Route path="/:matchSlug/:matchId" component={MatchPage} />
          <Route path="/:filter" component={MatchcenterPage} />
          <Route path="/" component={MatchcenterPage} />
        </Switch>
      </Suspense>
    </>
  );
};

export default MatchcenterApp;
